import SEOMeta from "@/components/SEOMeta";
import NavbarNew from "@/components/NavbarNew";
import FooterNew from "@/components/FooterNew";
import ContactNew from "@/components/ContactNew";

const Contato = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOMeta
        title="Contato"
        description="Diagnóstico gratuito de 30 minutos: site, sistema ou automação — a gente olha seu negócio junto e eu digo o que vale fazer primeiro."
        canonicalUrl="/contato"
      />
      <NavbarNew />
      <main>
        <ContactNew />
      </main>
      <FooterNew />
    </div>
  );
};

export default Contato;
